import converter from "number-to-words";
import moment from "moment-timezone";
import { parse } from "dotenv";

export function useFormatter() {
	const formatNumber = (num, dec = 0) => {
		let res = "";
		if (num != null && !Number.isNaN(num)) {
			num = parseFloat(num);
			if (dec == 0) {
				res = Math.round(num)
					.toString()
					.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			} else {
				res = num.toFixed(dec).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			}
		} else {
			res = "-";
		}
		return res;
	};

	const europeanFormatNumber = (num, dec = 0) => {
		let res = "";
		if (num != null && !Number.isNaN(num)) {
			num = parseFloat(num);
			if (dec == 0) {
				res = Math.round(num)
					.toString()
					.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
			} else {
				const fixedValue = num.toFixed(dec);
				const [intPart, decimalPart] = fixedValue.split(".");
				const formattedIntPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
				res = `${formattedIntPart},${decimalPart}`;
			}
		} else {
			res = "-";
		}
		return res;
	};
	
	const formatNumberStr = (num) => {
		let res = "";

		if (num != null && !Number.isNaN(num)) {
			if (num < 10) res = `0${num}`;
			else res = num;
		} else res = "-";

		return res;
	};

	const isEmpty = (obj) => {
		for (var key in obj) {
			if (obj.hasOwnProperty(key)) return false;
		}
		return true;
	};

	return [formatNumber, formatNumberStr, isEmpty, europeanFormatNumber];
}

export const abbGreek = (num, unit) => {
	const tempNum = parseFloat(num);
	const firstLetter = unit.charAt(0);
	const otherLetters = unit.slice(1);

	const lookup =
		firstLetter !== "k"
			? [
				{ value: 1, symbol: " " },
				{ value: 1e3, symbol: " k" },
				{ value: 1e6, symbol: " M" },
				{ value: 1e9, symbol: " G" },
				{ value: 1e12, symbol: " T" },
				{ value: 1e15, symbol: " P" },
				{ value: 1e18, symbol: " E" },
			]
			: [
				{ value: 1, symbol: " k" },
				{ value: 1e3, symbol: " M" },
				{ value: 1e6, symbol: " G" },
				{ value: 1e9, symbol: " T" },
				{ value: 1e12, symbol: " P" },
				{ value: 1e15, symbol: " E" },
			];
	const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
	const item = lookup
		.slice()
		.reverse()
		.find(function (item) {
			return tempNum >= item.value;
		});
	return item
		? (tempNum / item.value).toFixed(0).replace(rx, "$1") + item.symbol + otherLetters
		: "0 " + otherLetters;
};

export const numToWordsBaht = (number) => {
	if (!isNaN(number)) {
		// Split number to real and decimal numbers
		const numberSplit = number.toString().split(".");

		// Current Strings
		const currencyStr = ["Baht", "Satang"];

		// Concat each number split to its currency string
		const numberWords = numberSplit.map(
			(number, i) => `${converter.toWords(number)} ${currencyStr[i]}`
		);

		// Join both number splits to 1 full string
		const combinedStr = numberWords.join(" and ");

		return combinedStr;
	} else return "-";
};

export const numToWords = (number) => {
	if (!isNaN(number)) return converter.toWords(number);
	else return "-";
};

const removeDash = (str) => str.replaceAll("-", "");

export const formatPeriodStr = (dates) =>
	`${removeDash(dates[0])}-${removeDash(dates[1])}`;

export const toTitleCase = (str) => {
	return str.replace(/\w\S*/g, function (txt) {
		return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	});
};

/**
 * Group sites into array of n sites
 * @param {Sites array} data
 * @param {Size of array group} n
 */
export const groupArr = (data, n) => {
	let group = [];
	for (var i = 0, j = 0; i < data.length; i++) {
		if (i >= n && i % n === 0) j++;
		group[j] = group[j] || [];
		group[j].push(data[i]);
	}
	return group;
};

export const dateFormat = (input) => {
	return moment(input).format("YYYY-MM-DD");
}

export const dateTimeFormat = (input) => {
	return moment(input).format("YYYY-MM-DD HH:mm");
}

export const dateTimeFormatCompare = (input) => {
	return moment(input).format("YYYYMMDDHHmm");
}

export const dateTimeForm = (input) => {
	return moment(input).format("YYYY-MM-DDTHH:mm");
}

export const changeToNull = (input) => {
	if (input === undefined || input === "") return null;
	return input;
}

export const isValEmpty = (val) => val === null || val === undefined || val === "";
export const isNaN = (val) => isValEmpty(val) || Number.isNaN(val);

export const float_format = (num, dec) => {
	if (isNaN(num)) return "-";
	const _num = parseFloat(num).toFixed(dec);
	return parseFloat(_num).toLocaleString("en");
}

